import { createStorageAtomFactory, withSerialization } from '@exodus/atoms';
import { OrderSet } from '@exodus/models';
import { getAllOrderInstances } from '../module/utils.js';
const createOrdersAtom = ({ storage, assetsModule, logger, }) => {
    const createAtom = createStorageAtomFactory({
        storage: storage,
    });
    const atom = createAtom({ key: 'orders', defaultValue: [] });
    const serialize = (orderSet) => [...orderSet].map((order) => order.toJSON());
    const deserialize = (json) => {
        if (!json || json.length === 0)
            return OrderSet.EMPTY;
        const orders = getAllOrderInstances({ orders: json, assetsModule, logger });
        return OrderSet.fromArray(orders);
    };
    return withSerialization({ atom, serialize, deserialize, pure: true });
};
export default createOrdersAtom;
